<template>
  <div class="step-container">
    <div class="title">快速入门能链企服 <span>3步帮您玩转管理后台</span></div>
    <div class="step-content">
      <div class="step-list-title">
        <div class="step-list-title--item"><span>1</span><div class="step-title">批量邀请员工</div></div>
        <div class="line" />
        <div class="step-list-title--item"><span>2</span><div class="step-title">企业充值</div></div>
        <div class="line" />
        <div class="step-list-title--item"><span>3</span><div class="step-title">分配额度</div></div>
      </div>
      <div class="step-list">
        <div class="step-list--item">
          <div class="desc">邀请员工到企业, 管理员工加油行为, 并为他们设置加油额度。</div>
          <div class="btns">
            <button class="primary" @click.prevent="onGoInvite">邀请员工</button>
            <!-- <button @click.prevent="txcOpen(94969)">查看教程</button> -->
          </div>
        </div>
        <div class="step-list--item">
          <div class="desc">预存费用，当员工加油时，由企业支付费用。</div>
          <div class="btns">
            <button class="primary" @click.prevent="onGoFinance">去充值</button>
            <!-- <button @click.prevent="txcOpen(94984)">查看教程</button> -->
          </div>
        </div>
        <div class="step-list--item">
          <div class="desc">为员工和车辆分配额度，员工加油时可选择使用员工额度或车辆额度支付。</div>
          <div class="btns">
            <!-- <button @click.prevent="txcOpen(99173)">查看教程</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import router from '@/router';
import { txcOpen } from '@/utils/txc';

const route = useRoute();

// 操作引导
const onGoInvite = () => {
  router.push({ name: 'main.staff.invite', query: { goback: route.fullPath } });
};
const onGoFinance = () => {
  router.push({ name: 'finance.top_up' });
};
</script>

<style lang="scss" scoped>
.step-container {
  width: 100%;
  padding: 20px;
  border-radius: 16px;
  border: 1.5px solid #fff;
  background: #fff;
  background: url(https://nl-frontend-test-1305297355.cos.ap-beijing.myqcloud.com/nl-saas/step-bg.png) no-repeat top right;
  background-size: contain;
  background-color: #ebf4ff;

  .title {
    color: #1d2129;
    font-size: 20px;
    font-weight: 600;
    line-height: 32px;

    span {
      padding-left: 10px;
      color: #86909c;
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
    }
  }

  .step-content {
    width: calc(100% - 403px);
    margin-top: 16px;
    padding: 23px 20px 28px;
    border-radius: 12px;
    border: 1px solid #fff;
    background: linear-gradient(90deg, #fff 0%, rgba(255, 255, 255, 0.7) 100%);
    backdrop-filter: blur(4px);
  }

  .step-list-title {
    display: flex;

    .line {
      width: 100%;
      height: 1px;
      border: none;
      background: #e3f1ff;
      position: relative;
      left: 0;
      top: -9px;
      margin: 21px 17px 0;
    }

    .step-list-title--item {
      display: flex;
      flex-shrink: 0;

      &:last-child {
        width: 234px;
      }

      span {
        width: 22px;
        height: 22px;
        flex-shrink: 0;
        background: #ecf1fd;
        color: #1d2129;
        font-size: 14px;
        font-weight: 600;
        line-height: 22px; /* 142.857% */
        text-align: center;
        border-radius: 11px;
        margin-right: 8px;
      }

      .step-title {
        color: #1d2129;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px; /* 150% */
        display: flex;
      }
    }
  }

  .step-list {
    display: flex;
    justify-content: space-between;

    .step-list--item {
      &:first-child {
        margin-left: 30px;
      }

      &:nth-child(2) {
        margin-left: 30px;
      }
    }     

    .desc {
      max-width: 204px;
      margin: 8px 0 16px;
      color: #86909c;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px; /* 133.333% */
    }

    .btns {
      button {
        width: 80px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border-radius: 8px;
        background: #f2f3f7;
        color: #4e5969;
        font-size: 14px;
        font-weight: 400;

        &.primary {
          background: #2982ff;
          margin-right: 8px;
          color: #fff;
        }
      }
    }
  }
}
</style>
